import { blue400, grey50, grey450, white100 } from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import styled, { css } from 'styled-components'

export default css`
  /* TODO: Standardize z-index */
  z-index: 10;
  &.small {
    --border-radius: ${spacing(1)};
  }
  &.medium {
    --border-radius: ${spacing(2)};
  }

  &[data-popper-reference-hidden] {
    visibility: hidden;
    pointer-events: none;
  }

  .menu {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    margin: ${spacing(2)} 0;
    list-style: none;
    background-color: ${white100};
    border: 1px solid ${blue400};
    border-radius: var(--border-radius);
  }

  .search-container {
    display: flex;
    gap: ${spacing(2)};
    align-items: center;
    border-radius: var(--border-radius) var(--border-radius) 0 0;
    background: ${grey50};
    border-bottom: 1px solid ${grey450};
    &.small {
      padding: ${spacing(2)} ${spacing(3)};
    }
    &.medium {
      padding: ${spacing(2)} ${spacing(5)};
    }

    &.hidden {
      height: 0;
      padding: 0;
      opacity: 0;
    }

    & .search-icon {
      &.small {
        min-width: ${spacing(4)};
        min-height: ${spacing(4)};
      }
      &.medium {
        min-width: ${spacing(6)};
        min-height: ${spacing(6)};
      }
    }
  }

  .scroll-container {
    overflow: scroll;
    flex: 1;
  }

  .reset-container {
    border-radius: 0 0 var(--border-radius) var(--border-radius);
    background: ${grey50};
    padding: ${spacing(2)};
    border-top: 1px solid ${grey450};

    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .reset-button {
    padding: ${spacing(2)};
  }
`

// in order to dynamically set width, we need to be able to pass props in
export const StyledListbox = styled.div<{
  width?: number
  dropdownOptionsCount: number
}>`
  width: ${({ width }) => (width ? `${width}px` : `100%`)};
  min-width: 300px;
  // allows for dropdownOptionCount items + overflow so scrolling is obvious
  max-height: ${({ dropdownOptionsCount }) =>
    `calc(${spacing(13)} * (${dropdownOptionsCount} + 0.6))`};
`

// popper container is rendered separately in the DOM hierarchy, so it needs its own styles
export const popperStyles = css``
